<div class="row">
    <div class="col-md-12 text-end">
        <h3 class="organization_title mt-5">
            Organization Name <span>{{ currentOrganizationName }}</span>
        </h3>
    </div>
</div>
<div class="body" style="margin-top: 15px">
    <div class="">
        <div class="col-md-3"></div>
        <div class="section-title">
            <h3>Role Management</h3>
            <!-- <button type="button" class="btn primary-ebtn" style="position: absolute;right: 0;"
        (click)="openIDMSUserTypeModal()">Add
        New
        Role</button> -->
            <button type="button" class="btn primary-ebtn" *ngIf="isAddEnabled === true" style="position: absolute; right: 0" (click)="addNewSecurityRole()">
                Add New Role
            </button>
        </div>
        <div class="accordion" *ngIf="securityRoleList?.length">
            <div class="user-type-table">
                <mat-table [dataSource]="DataSource()" class="mat-elevation-z8">
                    <!-- User type coloumn -->
                    <ng-container matColumnDef="securityRoleName">
                        <mat-header-cell *matHeaderCellDef> <b>NAME</b> </mat-header-cell>
                        <mat-cell *matCellDef="let securityRoleData"> {{ securityRoleData.name }} </mat-cell>
                    </ng-container>

                    <!--Description Column-->
                    <ng-container matColumnDef="roleDescription">
                        <mat-header-cell *matHeaderCellDef> <b>DESCRIPTION</b> </mat-header-cell>
                        <mat-cell *matCellDef="let securityRoleData"> {{ securityRoleData.description }} </mat-cell>
                    </ng-container>

                    <!-- Actions coloumn -->
                    <ng-container matColumnDef="actions">
                        <mat-header-cell *matHeaderCellDef class="justify-content-end"> <b class="actions-column">ACTIONS</b> </mat-header-cell>
                        <mat-cell class="justify-content-end" *matCellDef="let securityRoleData">
                            <!--Edit User Type openEditUserTypeModal()-->
                            <mat-icon
                                matTooltip="copy"
                                (click)="copySecurityRole(securityRoleData)"
                                *ngIf="securityRoleData.isSysAdmin == false && isAddEnabled === true"
                                style="margin-right: 8px"
                                ><a href="javascript:void(0)">file_copy</a>
                            </mat-icon>
                            <mat-icon
                                matTooltip="edit"
                                (click)="editSecurityRole(securityRoleData)"
                                *ngIf="securityRoleData.isDerivedFromTemplate == false && isEditEnabled == true"
                                style="margin-right: 8px"
                                ><a href="javascript:void(0)">edit</a>
                            </mat-icon>
                            <!--deleteUserType()-->
                            <mat-icon
                                matTooltip="delete"
                                *ngIf="securityRoleData.isDerivedFromTemplate == false && isDeleteEnabled === true"
                                (click)="deleteSecurityRoles(securityRoleData)"
                                style="margin-right: 8px"
                                ><a href="javascript:void(0)">delete</a>
                            </mat-icon>
                            <mat-icon #tooltip="matTooltip" matTooltip="View" (click)="viewRolesPermissions(securityRoleData)">
                                <a href="javascript:void(0)">remove_red_eye</a>
                            </mat-icon>
                            <mat-icon class="permission-icon">
                                <i class="fas fa-user-lock permission-icon" style="display: none" (click)="openUserTypePermissionModal()"></i>
                            </mat-icon>
                        </mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
                </mat-table>
            </div>
        </div>
    </div>
</div>
